import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import { DeleteModalIcon } from "../../../utils/Icons";
import { deleteCategoryRequest } from "../../../store/Categories/actions";

const DeleteCategory = ({ open, closeModal, categoryInfo }) => {
  const lang = useSelector((state) => state.locale.lang);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { categories, shared } = messages[lang];

  const handleConfirmDelete = () => {
    dispatch(
      deleteCategoryRequest({
        data: {
          Id: categoryInfo.id
        },
        src: categoryInfo.src,
        params: categoryInfo.params,
        navigate
      })
    );
    closeModal();
  };

  const deleteCategoryContent = () => {
    return (
      <div className="delete-category-container d-flex flex-column justify-content-center align-items-center">
        <DeleteModalIcon />
        <div className="delete-category-content mt-2 d-flex flex-column justify-content-center align-items-center text-center">
          <Typography className="fsize-20 fweight-700">
            {`${categories.deleteCategory.content} "${categoryInfo.name}"`}
          </Typography>
          <Typography className="text-secondary fsize-14 mt-2 fweight-600">
            {categories.deleteCategory.confirmationContent}
          </Typography>
          <Typography className="text-secondary fsize-14 mt-2 fweight-600">
            {categories.deleteCategory.subConfirmationContent}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={open}
      handleConfirm={() => {
        handleConfirmDelete();
      }}
      handleClose={closeModal}
      isContentText={false}
      content={deleteCategoryContent()}
      hasActions={true}
      confirmBtnTxt={shared.delete}
      cancelBtnTxt={shared.cancel}
      handleCancel={closeModal}
      showCloseIcon
      title
      confirmBtnClass="danger-btn border-radius-12 ps-5 pe-5"
      cancelBtnClass="text-secondary border-radius-12 ps-5 pe-5"
      maxWidth={"xs"}
    />
  );
};

export default DeleteCategory;

DeleteCategory.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  categoryInfo: PropTypes.object.isRequired
};
